import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import InfoRow from '../InfoRow/InfoRow';
import { base64ToByteArray, byteArrayToBase64Src } from '../../../../../helpers/tools';
import moment from 'moment';
import { useVisita } from '../../../../../context/VisitaContext';
import { adaptVisitaArchivoModelInput } from '../../../../../data/graphQL/mutations/Visitas/saveArchivoVisita';
import { tipoArchivoVisita } from '../../../constants/TipoArchivosVisita';

import { GET_ARCHIVO_VISITA } from '../../../../../data/graphQL/queries/MisVisitas/getArchivoVisita';
import toast from 'react-hot-toast';

const VisitaFirmaInput = ({ inputName, idVisita, handleChange, readOnly, ensureIdVisita, disableChange }) => {

  const { visita, setVisita, saveArchivoVisita } = useVisita();

  const signatureRef = useRef(null);
  const [previousSignature, setPreviousSignature] = useState(null);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);

  const { data, error, loading } = useQuery(GET_ARCHIVO_VISITA, {
    variables: { idArchivoVisita: visita?.firmaPaciente?.idArchivo },
    skip: !visita?.firmaPaciente?.idArchivo
  });

  useEffect(() => {
    if (error) {
      toast.error('Error al obtener la firma');
      return;
    }
    if (data?.archivoVisita?.valorEsperado) {
      const updatedFile = data.archivoVisita.valorEsperado;

      const imageSrc = byteArrayToBase64Src(updatedFile.contentType, updatedFile.archivo);

      setPreviousSignature(imageSrc);
      handleChange(inputName, updatedFile);
    }
  }, [data, error]);

  const limpiarFirma = () => {
    setPreviousSignature(null);
    signatureRef.current.clear();
    setIsSignatureEmpty(true);
    handleChange(inputName, null);
  };

  const guardarFirma = async () => {
    setSaveIsLoading(true);
    let idVisitaGuardar = idVisita;
    if (typeof ensureIdVisita === "function") {
      const nuevaIdVisita = await ensureIdVisita();
      if (!nuevaIdVisita) {
        setSaveIsLoading(false);
        return;
      }
      idVisitaGuardar = nuevaIdVisita;
    }
    const value = signatureRef.current.getTrimmedCanvas().toDataURL('image/png');

    const base64Data = value.split(',')[1];

    const newValue = {
      idArchivo: 0,
      idTipoArchivoDocumento: tipoArchivoVisita.FIRMA,
      idVisita: idVisitaGuardar,
      titulo: `firma_paciente_familiar_visita_${idVisitaGuardar}.png`,
      archivo: base64ToByteArray(base64Data),
      extension: '.png',
      contentType: 'image/png',
      fechaAlta: moment().format('YYYY/MM/DD')
    };
    const res = await saveArchivoVisita({
      variables: {
        input: adaptVisitaArchivoModelInput(newValue)
      }
    });

    const newIdArchivo = res?.data?.saveArchivoVisita?.valorEsperado;

    newValue.idArchivo = newIdArchivo;

    setPreviousSignature(value);
    setVisita((prev) => ({ ...prev, firmaPaciente: newValue }));

    handleChange(inputName, newValue);

    setSaveIsLoading(false);
  };

  return (
    <>
      <InfoRow label='Firma Paciente / Familiar' />
      {previousSignature === null ?

        <SignaturePad
          ref={signatureRef}
          disabled={disableChange}
          penColor='#0f0f0f'
          backgroundColor='#fff'
          canvasProps={{
            className: 'signatureCanvas'
          }}
          clearOnResize={false}
          onEnd={() => setIsSignatureEmpty(signatureRef.current.isEmpty())}
          onClear={() => setIsSignatureEmpty(true)}
        /> :
        <img className='signatureCanvas' src={previousSignature} alt='Firma' />
      }
      <div className='actionsSignature'>
        <Button
          className='signatureButton'
          size='medium'
          variant='outlined'
          onClick={limpiarFirma}
          disabled={
            saveIsLoading ||
            signatureRef.current == null ||
            isSignatureEmpty ||
            readOnly ||
            disableChange ||
            !!previousSignature
          }
        >
          Limpiar
        </Button>
        <Button
          className='signatureButton'
          size='medium'
          variant='contained'
          onClick={guardarFirma}
          loading={saveIsLoading}
          disabled={
            isSignatureEmpty ||
            readOnly ||
            disableChange ||
            !!previousSignature
          }
        >
          Confirmar Firma
        </Button>
      </div>
    </>);

};

export default VisitaFirmaInput;